import type { Theme } from "@mui/material"
import { CustomerSearchTheme } from "core/themes/src/definitions/components.types"

export const createCustomerSearchTheme = (theme: Theme): CustomerSearchTheme => ({
    defaultProps: {
        autoFocus: true,
    },
})
